import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { MdDelete } from "react-icons/md";
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ViewWarehouse from '../../../../component/b2c/models/ViewWarehouse';
import { useMyContext } from '../../../../context/MyContext';
import Swal from 'sweetalert2';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../../css/custom-scrollbar.css';
import { LuWarehouse, LuMapPin, LuPhone, LuBoxes, LuPackageSearch } from "react-icons/lu";
import axios from 'axios';
import { CgSearch } from "react-icons/cg";
import { IoClose } from "react-icons/io5";
import { Base_Url, deletewarehouse, Warehouselist } from '../../../../config/config';
import AddWarehousePopup from '../addwarehouse/AddWarehousePopup.jsx';
import { PlusIcon } from 'lucide-react';

const AllWarehouses = () => {
  const [totalOrders, setTotalOrders] = useState(0);
  const { isDarkMode } = useMyContext();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const { isToggleSidebar } = useMyContext();
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const navigate = useNavigate();
  const [loadingWarehouseId, setloadingWarehouseId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // NEW: controls the right-side "Add Warehouse" drawer
  const [isAddDrawerOpen, setIsAddDrawerOpen] = useState(false);

  useEffect(() => {
    fetchWarehouses()
  }, [page, limit]);


  const fetchWarehouses = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    try {
      const pageNumber = Number(page) || 1;
      const limitNumber = Number(limit) || 10;
      const urlWarehouse = `${Base_Url}${Warehouselist}?page=${pageNumber}&limit=${limitNumber}`
      const response = await fetch(urlWarehouse, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cusid,
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.status === "SUCCESS" && Array.isArray(result.data)) {
        setWarehouses(result.data);
        setTotalOrders(result.pagination.totalItems || 0);
      } else {
        console.error('Unexpected response format:', result);
      }
    } catch (error) {
      console.error('Error fetching warehouse data:', error);
    }
  };


  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = warehouses.slice(indexOfFirstItem, indexOfLastItem);

  const handleViewClick = (warehouse) => {
    setSelectedWarehouse(warehouse);
    setIsPopupOpen(true);
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleNavigation = () => {
    navigate('/dashboard');
  };

  const handleDelete = async (id) => {
    setloadingWarehouseId(id);
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this deletion!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#000000',
      cancelButtonColor: '#666666',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const urldelete = Base_Url + deletewarehouse;
        try {
          const token = localStorage.getItem('token');
          const cusid = localStorage.getItem('cus_id');
          const data = {
            warehouseId: id
          };
          const response = await axios.post(urldelete, data, {
            headers: {
              token,
              cus_id: cusid,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          });

          if (response.data.status === "SUCCESS") {
            setWarehouses((prevWarehouses) => prevWarehouses.filter(warehouse => warehouse.id !== id));
            setTotalOrders((prev) => prev - 1);

            Swal.fire(
              'Deleted!',
              response.data.message || 'Warehouse has been deleted successfully.',
              'success'
            );
          } else {
            Swal.fire(
              'Error!',
              'Unexpected response format: ' + response.data.message,
              'error'
            );
          }
          setloadingWarehouseId(null);
        } catch (error) {
          Swal.fire(
            'Error!',
            'Error deleting warehouse: ' + error.message,
            'error'
          );
        }
      }
    });
  };


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };


  const getFilteredWarehouse = () => {
    if (!searchTerm.trim()) {
      return warehouses;
    }

    const term = searchTerm.toLowerCase();
    return warehouses.filter(warehouse => {
      return (
        (warehouse.name?.toString().toLowerCase().includes(term)) ||
        (warehouse.phone?.toLowerCase().includes(term)) ||
        (warehouse.id?.toString().toLowerCase().includes(term))
      );
    });
  };

  const displayWarehouses = getFilteredWarehouse();
      const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

  // NEW: called by AddWarehouse after a successful create
  const handleAddSuccess = () => {
    setIsAddDrawerOpen(false);
    setPage(1);
    fetchWarehouses();
  };

  return (
    <>
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'bg-black' : 'bg-white'}`}>
         <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />
       
             <NavBar />
             <div className="flex flex-1 overflow-hidden">
               {isToggleSidebar && (
                 <div className={`w-64 m-3 rounded-3xl ${glass} overflow-hidden`}>
                   <Sidebar />
                 </div>
               )}

          <div className={`flex flex-1 flex-col mb-2 w-full overflow-y-auto p-3 ${isDarkMode ? 'bg-black text-white' : 'bg-gray-100'}`}>

            {/* Page header */}
            <div className="flex flex-col sm:flex-row sm:items-center items-center sm:justify-between gap-3 mb-2">
              <div className="flex items-center gap-2">
                <div className={`flex items-center justify-center w-8 h-8 rounded-lg border flex-shrink-0 ${isDarkMode ? 'border-white/10' : 'border-black/60'}`}>
                  <LuWarehouse color='brown' className={`text-sm ${isDarkMode ? 'text-white' : 'text-black'}`} size={16} />
                </div>
                <div>
                  <h1 className={`text-[16px] font-bold leading-tight ${isDarkMode ? 'text-white' : 'text-black'}`}>
                    All Warehouses
                  </h1>
                  <p className={`text-[9px] ${isDarkMode ? 'text-white/40' : 'text-black/40'}`}>
                    Manage every registered warehouse location
                  </p>
                </div>
              </div>
                {/* Search bar */}
            <div className="w-[60%]">
              <div className="relative flex items-center border bg-white grow py-1 rounded-lg border-gray-500">
                <div className="pl-2.5 pr-2">
                  <CgSearch color='blue' className={`text-sm transition-colors duration-200 ${isDarkMode ? 'text-white/30' : 'text-black/30'}`} size={15} />
                </div>


                <input
                  type="text"
                  placeholder="Search by ID, phone or name"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className={`flex-1 py-1.5 pr-2 bg-transparent outline-none text-[10px] ${isDarkMode ? 'text-white placeholder-white/30' : 'text-black placeholder-black'}`}
                />

                {searchTerm && (
                  <button
                    onClick={() => handleSearchChange({ target: { value: '' } })}
                    className={`mr-2 p-0.5 rounded-full transition-colors duration-200 ${isDarkMode ? 'text-white/30 hover:text-white/60' : 'text-black/30 hover:text-black/60'}`}
                  >
                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
              {/* <div className={`flex items-center gap-2 rounded-lg border px-3 py-1.5 border-gray-600`}>
                <div className={`flex items-center justify-center w-7 h-7 border border-gray-600 rounded-lg flex-shrink-0 ${isDarkMode ? 'bg-white/5' : 'bg-black/5'}`}>
                  <LuBoxes color='blue' size={14} className={isDarkMode ? 'text-white/60' : 'text-black/60'} />
                </div>
                <div>
                  <p className={`text-[8px] font-medium ${isDarkMode ? 'text-white/40' : 'text-black/40'}`}>Total Warehouses</p>
                  <p className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>{totalOrders}</p>
                </div>
              </div> */}
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setIsAddDrawerOpen(true)}
                  className={`text-[11px] flex gap-1 items-center font-semibold px-3 py-2 rounded-lg transition-all duration-200 active:scale-[0.98] ${isDarkMode ? 'bg-white text-black hover:bg-white/90' : 'bg-violet-600 text-white hover:bg-blue-500'}`}
                >
                  <PlusIcon size={14}/> Create Warehouse
                </button>
              </div>
            </div>

          

            {/* Table with scroll - FIXED */}
            <div className={`border rounded-lg overflow-hidden flex-1 flex flex-col min-h-0 ${isDarkMode ? 'border-white/10' : 'border-black/30'}`}>
              {/* Scrollable table container */}
              <div className="flex-1 overflow-y-auto overflow-x-auto custom-scrollbar">
                <table className="min-w-full table-auto">
                  <thead className={`${isDarkMode ? 'bg-white/5' : 'bg-violet-700'} border-b ${isDarkMode ? 'border-white/10' : 'border-black/10'} sticky top-0 z-10`}>
                    <tr>
                      <th className={`px-2.5 py-1.5 text-left text-[12px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-white/60' : 'text-white'}`}>Warehouse</th>
                      <th className={`px-2.5 py-1.5 text-left text-[12px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-white/60' : 'text-white'}`}>Contact</th>
                      <th className={`px-2.5 py-1.5 text-left text-[12px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-white/60' : 'text-white'}`}>Location</th>
                      <th className={`px-2.5 py-1.5 text-left text-[12px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-white/60' : 'text-white'}`}>Status</th>
                      <th className={`px-2.5 py-1.5 text-right text-[12px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-white/60' : 'text-white'}`}>Actions</th>
                    </tr>
                  </thead>
                  <tbody className={`divide-y ${isDarkMode ? 'bg-white' : 'bg-white'}`}>
                    {displayWarehouses.length === 0 ? (
                      <tr>
                        <td colSpan={5} className="py-6">
                          <div className="flex flex-col items-center justify-center text-center gap-1.5">
                            <div className={`flex items-center justify-center w-9 h-9 rounded-lg ${isDarkMode ? 'bg-white/5' : 'bg-white'}`}>
                              <LuPackageSearch size={16} className={isDarkMode ? 'text-white/30' : 'text-black/30'} />
                            </div>
                            <p className={`text-[10px] font-semibold ${isDarkMode ? 'text-white/60' : 'text-black/60'}`}>
                              No warehouses found
                            </p>
                            <p className={`text-[8px] ${isDarkMode ? 'text-white/30' : 'text-black/30'}`}>
                              Try adjusting your search term.
                            </p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      displayWarehouses.map((warehouse) => (
                        <tr
                          key={warehouse.id}
                          className={`transition-colors duration-150 ${isDarkMode ? 'hover:bg-white/5' : 'hover:bg-black/5'}`}
                        >
                          <td className="px-2.5 py-1.5">
                            <div className="flex items-center gap-2">
                              <div className={`flex items-center justify-center w-7 h-7 rounded-lg text-[12px] font-bold flex-shrink-0 ${isDarkMode ? 'bg-white text-black' : 'bg-violet-700 text-white'}`}>
                                {warehouse.name?.toString().charAt(0).toUpperCase() || 'W'}
                              </div>
                              <div className="min-w-0">
                                <p className={`text-[12px] font-semibold truncate ${isDarkMode ? 'text-white' : 'text-black'}`}>
                                  {warehouse.name}
                                </p>
                                <p className={`text-[8px] ${isDarkMode ? 'text-white/30' : 'text-black/80'}`}>
                                  ID: {warehouse.id}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td className="px-2.5 py-1.5">
                            <p className={`text-[12px] truncate max-w-[160px] ${isDarkMode ? 'text-white/70' : 'text-black/70'}`}>
                              {warehouse.email}
                            </p>
                            <p className={`flex items-center gap-0.5 text-[12px] font-mono mt-0.5 ${isDarkMode ? 'text-white/40' : 'text-black/40'}`}>
                              <LuPhone color='violet' fill='purple' size={10} />
                              {warehouse.phone}
                            </p>
                          </td>
                          <td className="px-2.5 py-1.5">
                            <p className={`flex items-center gap-0.5 text-[12px] ${isDarkMode ? 'text-white/70' : 'text-black/70'}`}>
                              <LuMapPin color='blue' size={10} className="flex-shrink-0" />
                              {[warehouse.city, warehouse.state, warehouse.country].filter(Boolean).join(', ')}
                            </p>
                          </td>
                          <td className="px-2.5 py-1.5">
                            <span className={`inline-flex items-center px-1.5 py-0.5 rounded-full text-[12px] font-medium ${warehouse.status === 'Active'
                              ? isDarkMode ? 'bg-white/10 text-white' : 'bg-green-600/10 text-black'
                              : isDarkMode ? 'bg-white/5 text-white/40' : 'bg-white shadow-xl border border-gray-400 text-black/60'
                              }`}>
                              <span className={`w-1.5 h-1.5 rounded-full mr-1 ${warehouse.status === 'Active'
                                ? isDarkMode ? 'bg-white' : 'bg-black'
                                : isDarkMode ? 'bg-white/20' : 'bg-green-600'
                                }`}></span>
                              {warehouse.status || 'Active'}
                            </span>
                          </td>
                          <td className="px-2.5 py-1.5">
                            <div className="flex items-center justify-end gap-1">
                              <button
                                onClick={() => handleViewClick(warehouse)}
                                aria-label="View warehouse"
                                className={`p-1 rounded-lg transition-colors ${isDarkMode ? 'hover:bg-white/10' : 'hover:bg-black/10'}`}
                              >
                                <IoMdEye color='blue' size={14} className={isDarkMode ? 'text-white/60' : 'text-black/60'} />
                              </button>
                              <button
                                onClick={() => handleDelete(warehouse.id)}
                                aria-label="Delete warehouse"
                                disabled={loadingWarehouseId === warehouse.id}
                                className={`p-1 rounded-lg transition-colors ${isDarkMode ? 'hover:bg-white/10' : 'hover:bg-black/10'} disabled:opacity-40`}
                              >
                                {loadingWarehouseId === warehouse.id ? (
                                  <span className={`animate-spin text-[10px] ${isDarkMode ? 'text-white' : 'text-black'}`}>⏳</span>
                                ) : (
                                  <MdDelete color='red' size={14} className={isDarkMode ? 'text-white/60' : 'text-black/60'} />
                                )}
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Footer: count, page size, pagination - fixed at bottom */}
              <div className={`flex flex-col sm:flex-row justify-between items-center gap-2 px-3 py-2 border-t flex-shrink-0 ${isDarkMode ? 'border-white/10' : 'border-black/10'}`}>
                <span className={`text-[12px] font-medium ${isDarkMode ? 'text-white/40' : 'text-black/40'}`}>
                  {`Total Warehouses: ${totalOrders}`}
                </span>

                <div className="flex items-center gap-2">
                  <select
                    id="limit"
                    value={limit}
                    onChange={handleLimitChange}
                    className={`border rounded-lg px-1.5 py-1 text-[12px] outline-none focus:ring-1 ${isDarkMode ? 'bg-black border-white/20 text-white focus:ring-white/50' : 'bg-white border-black/20 text-black focus:ring-black/50'}`}
                    disabled={totalOrders < 10}
                  >
                    {totalOrders === 0 ? (
                      <option value={0}>0</option>
                    ) : (
                      <>
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={totalOrders}>All</option>
                      </>
                    )}
                  </select>

                  <Pagination
                    count={Math.ceil(totalOrders / limit)}
                    page={currentPage}
                    onChange={handlePaginationChange}
                    variant="outlined"
                    shape="rounded"
                    size="small"
                    renderItem={(item) => (
                      <PaginationItem
                        {...item}
                        sx={{
                          borderRadius: '6px',
                          color: isDarkMode ? '#ffffff' : '#000000',
                          borderColor: isDarkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
                          '&.Mui-selected': {
                            backgroundColor: isDarkMode ? '#ffffff' : '#000000',
                            color: isDarkMode ? '#000000' : '#ffffff',
                            borderColor: isDarkMode ? '#ffffff' : '#000000',
                          }
                        }}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <ViewWarehouse isopen={isPopupOpen} onClose={handleClose} warehouse={selectedWarehouse} />

        {/* NEW: Right-side "Add Warehouse" drawer */}
        <div
          className={`fixed inset-0 z-[60] transition-opacity duration-300 ${isAddDrawerOpen ? 'opacity-100 pointer-events-auto' : 'opacity-10 pointer-events-none'}`}
        >
          {/* backdrop */}
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setIsAddDrawerOpen(false)}
          />

          {/* sliding panel */}
          <div
            className={`absolute top-0 right-0 h-full w-full sm:w-[560px] overflow-y-auto shadow-2xl rounded-l-xl transform transition-transform duration-300 ease-in-out ${isAddDrawerOpen ? 'translate-x-0' : 'translate-x-full'} ${isDarkMode ? 'bg-black' : 'bg-white'}`}
          >
            <div className={`flex items-center justify-between px-3 py-2.5 border-b sticky top-0 z-10 ${isDarkMode ? 'bg-black border-white/10' : 'bg-white border-black/10'}`}>
              <h2 className={`text-[13px] font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>Add New Warehouse</h2>
              <button
                onClick={() => setIsAddDrawerOpen(false)}
                aria-label="Close"
                className={`p-1.5 rounded-lg transition-colors ${isDarkMode ? 'hover:bg-white/10 text-white' : 'hover:bg-black/10 text-black'}`}
              >
                <IoClose size={16} />
              </button>
            </div>

            {isAddDrawerOpen && (
              <AddWarehousePopup
                onClose={() => setIsAddDrawerOpen(false)}
                onSuccess={handleAddSuccess}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AllWarehouses;